export const EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

const FALLBACK_IMAGE = {
  desktop: 'https://media-api.xogrp.com/images/67ff73e7-e380-4c77-88ae-9800fd5c9b4e',
  mobile: 'https://media-api.xogrp.com/images/b1353065-db1e-496c-988a-e3182b5bf75c',
};

export default FALLBACK_IMAGE;
